import { LoadingOutlined } from '@/shared/ui/icons'
import type { SpinIcon } from '@/shared/ui/theme/settings'
import { Spin, type SpinProps } from 'antd'
import './UiSpin.scss'

type SpinIndicator = NonNullable<SpinProps['indicator']>

/** Icon nhận `className` từ AntD (`ant-spin-dot`) để theo cỡ chữ của Spin. */
type GlyphProps = { className?: string }

const cls = (extra: string, className?: string) =>
  className ? `ui-spin-glyph ${extra} ${className}` : `ui-spin-glyph ${extra}`

const Arc = ({ className }: GlyphProps) => (
  <span className={cls('ui-spin-glyph--arc', className)} role="presentation">
    <LoadingOutlined />
  </span>
)

const Dots = ({ className }: GlyphProps) => (
  <span className={cls('ui-spin-glyph--dots', className)} role="presentation">
    <i />
    <i />
    <i />
  </span>
)

const Orbit = ({ className }: GlyphProps) => (
  <span className={cls('ui-spin-glyph--orbit', className)} role="presentation">
    <i />
  </span>
)

const DualRing = ({ className }: GlyphProps) => (
  <span className={cls('ui-spin-glyph--dual-ring', className)} role="presentation">
    <i />
    <i />
  </span>
)

const Hourglass = ({ className }: GlyphProps) => (
  <span className={cls('ui-spin-glyph--hourglass', className)} role="presentation">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M6 2h12M6 22h12M7 2v4l5 6-5 6v4M17 2v4l-5 6 5 6v4" />
    </svg>
  </span>
)

const INDICATORS: Record<Exclude<SpinIcon, 'default'>, SpinIndicator> = {
  loading: <Arc />,
  dots: <Dots />,
  orbit: <Orbit />,
  'dual-ring': <DualRing />,
  hourglass: <Hourglass />,
}

/** `indicator` cho Spin AntD. 'default' trả undefined để giữ vòng xoay gốc của AntD. */
export const getSpinIndicator = (kind: SpinIcon): SpinIndicator | undefined =>
  kind === 'default' ? undefined : INDICATORS[kind]

/** Xem trước một icon (thẻ chọn trong Drawer thiết lập), không phụ thuộc icon đang lưu. */
export const SpinIconPreview = ({ kind }: { kind: SpinIcon }) => (
  <Spin size="small" indicator={getSpinIndicator(kind)} />
)
